export default "__VITE_ASSET__cd5da082__"